import { NavLink } from "react-router-dom";

const TABS = [
  { to: "/community/neighbourhood", label: "The Neighbourhood" },
  { to: "/community/local-businesses", label: "Local Businesses" },
  { to: "/community/events", label: "Community Events" },
];

export const CommunityNav = () => (
  <div className="border-b border-[#E890A7]/10 bg-[#0D0B0E]/80 backdrop-blur-md sticky top-0 z-30" data-testid="community-subnav">
    <div className="max-w-6xl mx-auto px-6 flex gap-2 sm:gap-6 overflow-x-auto">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          data-testid={`community-tab-${t.to.split("/").pop()}`}
          className={({ isActive }) =>
            `whitespace-nowrap py-4 text-sm border-b-2 transition-colors duration-300 ${
              isActive ? "border-[#E890A7] text-[#F2A7BA]" : "border-transparent text-slate-400 hover:text-[#F2A7BA]"
            }`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </div>
  </div>
);
